import { Button } from "@/components/ui/button"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { useMutation } from "@tanstack/react-query"
import { useState } from "react"
import { catalog } from "./api"
import { DocumentPreview } from "./DocumentPreview"

export function SavedOriginalActions({
  id,
  filename,
}: {
  id: string
  filename: string
}) {
  const { translate: t } = useTranslation()
  const [open, setOpen] = useState(false)
  const download = useMutation({
    mutationFn: () => catalog.download(id),
    // The signed URL is served as an attachment, so navigating to it downloads
    // without leaving the page; a popup opened after the request can be blocked.
    onSuccess: ({ url }) => window.location.assign(url),
  })
  return (
    <div className="space-y-2 mt-2">
      <div className="flex flex-wrap gap-2">
        {/\.pdf$/i.test(filename) && (
          <Button type="button" variant="outline" onClick={() => setOpen(true)}>
            {t("CI_REVIEW_VIEW")}
          </Button>
        )}
        <Button
          type="button"
          variant="outline"
          disabled={download.isPending}
          onClick={() => download.mutate()}
        >
          {t("CI_DOWNLOAD")}
        </Button>
      </div>
      {download.isError && <p role="alert">{t("CI_ERROR")}</p>}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-5xl">
          <DialogHeader>
            <DialogTitle>{filename}</DialogTitle>
          </DialogHeader>
          {open && <DocumentPreview id={id} />}
        </DialogContent>
      </Dialog>
    </div>
  )
}
